import { createElement } from 'react';
import './index.scss';
import { ProCard as OriginalCard } from '@ant-design/pro-components';
;
const ProCard = function ProCard({ layout = 'default', children, ...otherProps }) {
    console.log(11, layout, children, otherProps);
    return (createElement(OriginalCard, Object.assign({}, otherProps, { layout: layout }), children));
};
ProCard.displayName = 'ProCard';
export default ProCard;
